import {
    consoleLogger,
    CoreDI,
    errorReporter,
    inject,
    injectable,
    IService,
    SystemComponentType
} from '@gongxigames/framework/core';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';
import {consoleReceiver} from '@gongxigames/framework/slot/utils';

@injectable()
export class LoggerService implements IService {
    public static NAME = 'ErrorReportingService';
    public type: SystemComponentType = 'service';
    constructor(@inject(CoreDI.Settings) private readonly _settings: SlotSettings) {
        this.setConsoleLogger();
    }

    private setConsoleLogger(): void {
        const enabled = this._settings.get('debugger');

        if (enabled) {
            consoleLogger.addReceiver(consoleReceiver);
        } else {
            consoleLogger.addReceiver(errorReporter.receiver.bind(errorReporter));
        }
    }

    public destroy(): void {
        consoleLogger.removeAllReceivers();
        consoleLogger.clear();
    }
}
